import { render, staticRenderFns } from "./enterdetails.vue?vue&type=template&id=91f284de&scoped=true&"
import script from "./enterdetails.vue?vue&type=script&lang=js&"
export * from "./enterdetails.vue?vue&type=script&lang=js&"
import style0 from "./enterdetails.vue?vue&type=style&index=0&id=91f284de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f284de",
  null
  
)

export default component.exports